<template>
    <div>
      <div class="row">
        <div class="col-12 checkout-form-header">
          <span class="checkout-form-title">{{ t('preview.order.coupon.redeem') }}</span>
        </div>
        <div class="col-12 form-group customerCouponRedeemInput">
          <input type="text" name="coupon_code" class="form-control"
                 v-model="couponCode"
                 v-on:keyup="checkCoupon(couponCode)"
                 v-on:keyup.enter="checkCoupon(couponCode)"
                 :placeholder="t('preview.order.coupon.code')">
        </div>
        <div v-show="couponSuccess" class="col-12 coupon-code-alert">
          <div class="alert alert-sm alert-success text-center"
               id="js-coupon-code-text-success-msg">{{t('checkout.coupon.redeemed')}}</div>
        </div>
        <div v-show="couponError" class="col-12 coupon-code-alert">
          <div class="alert alert-sm alert-warning-secondary text-center"
               id="js-coupon-code-text-error-msg">{{t('checkout.coupon.invalid')}}</div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CheckoutCoupon',
  props: ['couponCode'],
  watch: {
    coupon (val) {
      this.couponCode = val
    }
  },
  computed: {
    ...mapGetters(['previewOrderData']),
    couponError () {
      return this.coupon.length > 0 && this.previewOrderData.couponDiscount === 0
    },
    couponSuccess () {
      return this.coupon.length > 0 && this.previewOrderData.couponDiscount > 0
    },
    coupon () {
      return this.previewOrderData.couponCode
    }
  },
  methods: {
    ...mapActions(['checkCoupon'])
  }
}
</script>
